import { connect } from 'react-redux';
import {
//   fetchCategories2,
//   selectCategory,
//   resetCurrentCategory,
//   editMultiCategories2,
//   deleteCategory2,
//   clearCategory2Status,
  fetchGroupCategories,
//   fetchCategory2Products,

  fetchCategories2B2B,
  selectCategoryB2B,
  resetCurrentCategoryB2B,
  editMultiCategories2B2B,
  deleteCategory2B2B,
  clearCategory2StatusB2B,
  fetchCategory2ProductsB2B,
} from '../../actions/products_actions';

import Category_2_B2B from '../../components/Products/category_2_b2b';

function mapStateToProps(state) {
  return {
    // categories: state.products.categories2,
    // categoryIsLoading: state.products.category2IsLoading,
    // categoryError: state.products.category2Error,

    // currentCategory: state.products.currentCategory,
    // multiIsEditing: state.products.multiCategory2IsEditing,
    // multiError: state.products.multiCategory2EditError,
    // multiEdited: state.products.multiCategory2Edited,
    // userPermissions: state.auth.userPermissions,
    // deletingCategory: state.products.deletingCategory2,
    // deleteCategorySuccess: state.products.deleteCategory2Success,
    // deleteCategoryError: state.products.deleteCategory2Error,
    // currentGroup: state.products.currentGroup,


    categories: state.products.categories2B2B,
    categoryIsLoading: state.products.category2IsLoadingB2B,
    categoryError: state.products.category2ErrorB2B,

    currentCategory: state.products.currentCategoryB2B,
    multiIsEditing: state.products.multiCategory2IsEditingB2B,
    multiError: state.products.multiCategory2EditErrorB2B,
    multiEdited: state.products.multiCategory2EditedB2B,
    userPermissions: state.auth.userPermissions,
    deletingCategory: state.products.deletingCategory2B2B,
    deleteCategorySuccess: state.products.deleteCategory2SuccessB2B,
    deleteCategoryError: state.products.deleteCategory2ErrorB2B,
    // currentGroup: state.products.currentGroup,
  };
}

export default connect(mapStateToProps, {
//   fetchCategories2,
//   selectCategory,
//   resetCurrentCategory,
//   editMultiCategories2,
//   deleteCategory2,
//   clearCategory2Status,
  fetchGroupCategories,
//   fetchCategory2Products,

  fetchCategories2B2B,
  selectCategoryB2B,
  resetCurrentCategoryB2B,
  editMultiCategories2B2B,
  deleteCategory2B2B,
  clearCategory2StatusB2B,
  //
  fetchCategory2ProductsB2B,
})(Category_2_B2B);



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/category_2_b2b.jsx